import { useTranslation } from 'react-i18next';
import { CampaignType } from '@anytag/graphql';
import { PostDetailsType } from '@anytag/shared-types';
import { PostModal, PostModalProps } from '../shared';
import { InfluencerPostDetailsTemplate } from '../influencer-post-details-modal';
import { EngagementPostDetailsTemplate } from '../engagement-post-details-modal';
import { MarketplacePostDetailsTemplate } from '../marketplace-post-details-modal';
import { TikTokSpecialPostDetailsTemplate } from '../tiktok-special-post-details-modal';

export type CampaignInfluencerPostDetailsType = Pick<PostDetailsType, 'id' | 'campaignType' | 'influencerId'>;

export interface CampaignPostDetailsModalProps<T extends CampaignInfluencerPostDetailsType>
  extends Pick<PostModalProps<T>, 'posts' | 'paramKey'> {
  mkpPostProps?: Pick<React.ComponentProps<typeof MarketplacePostDetailsTemplate>, 'hidePostHistory'>;
  engPostProps?: Pick<
    React.ComponentProps<typeof EngagementPostDetailsTemplate<T>>,
    'hasTrafficSource' | 'hidePostHistory' | 'footer'
  >;
}

export const CampaignPostDetailsModal = <T extends CampaignInfluencerPostDetailsType>({
  posts,
  paramKey,
  mkpPostProps,
  engPostProps
}: CampaignPostDetailsModalProps<T>) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts} paramKey={paramKey}>
      {({ selectedPost }) =>
        selectedPost.campaignType === CampaignType.ENGAGEMENT ? (
          <EngagementPostDetailsTemplate {...engPostProps} />
        ) : selectedPost.campaignType === CampaignType.MARKETPLACE ? (
          <MarketplacePostDetailsTemplate {...mkpPostProps} />
        ) : selectedPost.campaignType === CampaignType.TIKTOK_SPECIAL ? (
          <>
            <PostModal.Title>{t('Post Detail')}</PostModal.Title>
            <TikTokSpecialPostDetailsTemplate />
          </>
        ) : (
          <>
            <PostModal.Title>{t('Post Detail')}</PostModal.Title>
            <InfluencerPostDetailsTemplate />
          </>
        )
      }
    </PostModal>
  );
};
